import { render } from "./SettingUsers.vue?vue&type=template&id=ce49104c"
import script from "./SettingUsers.vue?vue&type=script&lang=js"
export * from "./SettingUsers.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\mlab\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__